import { Component, EventEmitter, Output } from '@angular/core';
import { SuperTableAddColumn } from '../../../../enums/super-table-add-column.enum';

@Component({
    selector: 'add-column',
    templateUrl: './add-column.component.html',
    styleUrls: ['./add-column.component.scss'],
})
export class AddColumnComponent {
    @Output() selectedOption: EventEmitter<SuperTableAddColumn> = new EventEmitter<SuperTableAddColumn>();

    superTableAddColumn = SuperTableAddColumn;

    selectOption(option: SuperTableAddColumn): void {
        this.selectedOption.emit(option);
    }
}
